import OutlineButton from '@/components/OutlineButton'
import VideoPlayer from '@/components/VideoPlayer'
import SvgLib from '@/components/SvgLib'
import { TimelineMax, Power2, Power3 } from 'gsap'
import 'DrawSVGPlugin'
import { bus } from '@/consts'

export default {
  name: 'Hero',
  template: '#hero-template',
  data () {
    return {
      modalActive: false,
      heroTl: new TimelineMax({paused: true}),
      heroVid: 0
    }
  },
  components: { OutlineButton, VideoPlayer, SvgLib },
  methods: {
    openModal (val) {
      this.heroVid = val
      this.modalActive = true
      if (val === 0) {
        this.trackEvent('Homepage', 'Homepage: Button: Watch Video')
      } else {
        this.trackEvent('Overview', 'Overview: Button: Clash Explained')
      }
    },
    buildHeroTl () {
      // logo
      this.logoPathEls = [this.$refs.path1, this.$refs.path2, this.$refs.path3, this.$refs.path4, this.$refs.path5]
      this.heroTl.fromTo(this.logoPathEls, 3, {drawSVG: '0% 0%'}, {drawSVG: '0% 100%', ease: Power3.easeInOut}, 0)
      this.heroTl.fromTo(this.logoPathEls, 0.6, {fill: 'rgba(14,20,27,0)'}, { fill: 'rgba(14,20,27,1)', ease: Power3.easeInOut }, 2.5)
      this.heroTl.fromTo(this.$refs.clash, 3, {scale: 1.1}, {scale: 1, ease: Power3.easeInOut}, 0)

      // subtitle
      this.heroTl.fromTo(this.$refs.subtitle, 0.6, {opacity: 0, y: 10}, { opacity: 1, y: 0, ease: Power2.easeInOut }, 1)

      // video cta
      if (this.vidOuter && this.vidInner && this.vidText) {
        this.heroTl.fromTo(this.$refs.vidOuter, 1, {opacity: 0, rotation: '-35deg'}, { opacity: 1, rotation: '0deg', ease: Power3.easeInOut }, 1)
        this.heroTl.fromTo(this.$refs.vidInner, 1.5, {opacity: 0}, {opacity: 1}, 1.5)
        this.heroTl.fromTo(this.$refs.vidText, 1.5, {opacity: 0}, {opacity: 1}, 1)
      }

      // scroll CTA
      this.heroTl.fromTo(this.$refs.scrollCTA, 0.6, {opacity: 0, y: 10}, { opacity: 1, y: 0, ease: Power2.easeInOut }, 2.5)
    }
  },
  mounted () {
    this.$nextTick(() => {
      if (!this.$store.state.introAnimationPlayed) {
        this.buildHeroTl()
        bus.$on('loadAnimation', () => {
          this.heroTl.play()
          this.$store.commit('setIntroAnimationPlayed', true)
        })
      }

      bus.$emit('closeOverlay')

      bus.$on('hero-video-end', () => {
        this.modalActive = false
      })

      if (this.$store.state.isMobile) {
        document.body.classList.add('sub-bar-visible')
      }
    })
  },
  beforeDestroy () {
    if (this.$store.state.isMobile) {
      document.body.classList.remove('sub-bar-visible')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Hero.js